import React, { Component } from 'react';
import {setParameterToMap} from "actions/index.js";
import {setParameterSliderDown} from "actions/index.js";
import { connect } from "react-redux";
import {setTrackSendVolume} from 'actions/index.js';
import TrackSendVolumeChangeEvent from 'session/TrackSendVolumeChangeEvent.js';
import {setContextualHelp} from "actions/index.js";
import {TRACK_SEND_A_SLIDER} from 'constants/contextual-help.js';
import {TRACK_SEND_B_SLIDER} from 'constants/contextual-help.js';
import ReactBootstrapSlider from 'react-bootstrap-slider';

class TrackSend extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleSendVolumeChange(volume) {
        this.props.setParameterSliderDown(this.parameter);
        this.props.track.setSendVolume(
            this.props.sendNumber,
            volume,
            false);
    }

    setContextualHelp(e, contextualHelp) {
        e.stopPropagation();
        this.props.setContextualHelp(contextualHelp);
    }

    get parameter() {
        return this.props.track.sendNodeVolumeParameters[this.props.sendNumber];
    }

    onMouseUp(e) {
        if (this.props.isMacroMapping) {
            e.stopPropagation();
            if (!this.parameter.isMapped) {
                this.props.setParameterToMap(this.parameter);
            }
            // map this one
        }
        this.props.setParameterSliderDown(undefined);
        this.parameter.automation.smoothen();
        this.parameter.mixAutomation.smoothen();
    }

    render() {
        let contextualHelp = this.props.sendNumber === 0 ?
            TRACK_SEND_A_SLIDER :
            TRACK_SEND_B_SLIDER;
        let className = "enabled effect track-send";
        if (this.props.isMacroMapping) {
            className += " plane-mapping";
        }
        return (
            <div
              onMouseUp={(e) => this.onMouseUp(e)} 
              onMouseOver={(e) => this.setContextualHelp(e, contextualHelp)}
              onMouseLeave={() => {
                  this.props.setContextualHelp(undefined);
              }}
              className={className}>
              <div className="effect-name">{this.props.send.getName()}</div>
              <div className="clear-fix"></div>
              <div className="parameter-box">
              <ReactBootstrapSlider
                    value={this.props.volume}
                    change={(e) => this.handleSendVolumeChange(e.target.value)}
                    slideStop={this.mouseDown}
                    step={0.1}
                    max={3}
                    min={-70}
                    orientation="horizontal"
                    reversed={false}
                />
              </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
        setParameterSliderDown: parameter => dispatch(setParameterSliderDown(parameter)),
        setParameterToMap: parameter => dispatch(setParameterToMap(parameter)),
        setTrackSendVolume: (trackNumber, sendNumber, volume) =>
            dispatch(setTrackSendVolume(trackNumber, sendNumber, volume)),
    }
};

const mapStateToProps = (state, props) => {
    let track = props.track 
    return {
        volume: track !== undefined ?
            track.sendNodeVolumeParameters[props.sendNumber].get() : 0,
        isRecordingMix: state.mix.isRecordingMix,
        isRecording: state.sequencer.isRecording,
        isMacroMapping: state.effects.isMacroMapping,
    };
};
 
export default connect(mapStateToProps, mapDispatchToProps)(TrackSend);
